<template>
  <div class="card">
    <div class="card card-custom" >
      <div class="card-header flex-wrap border-0 pt-6 pb-0">
        <div class="card-title">
          <h3 class="card-label">{{ $t('setting.template_build_key') }}</h3>
        </div>
      </div>
      <form class="form" @submit.prevent="createTemplateKey">
        <div class="modal-content">
          <div class="modal-body">
            <RequiredText />
            <div class="row">
              <Input
                  containerClass="col-12 mt-auto mb-10"
                  :name="`${id}-key`"
                  type="text"
                  :label="$t('setting.build_key')"
                  labelClass="form-label fs-6 text-black"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  :isRequired="true" size="lg"
                  :placeholder="$t('setting.build_key')"
                  v-model="formData.key"
              />

            </div>
          </div>
          <div class="modal-footer">
            <Button
                btn-class="btn-sm me-3"
                type="submit"
                id="submit_btn"
                btn-text="button.save"
                size="7px 30px"
                :is-loading="processing"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref,watch} from "vue";
import Input from "@/components/Input.vue";
import RequiredText from "@/components/RequiredText"
import Button from "@/components/Button"
import i18n from '@/plugins/i18n';
import {useStore} from "vuex";



const store = useStore()
const processing = ref(false)


const formData = ref({
  key: '',
})
const loading = ref(false)

const templateKey = computed(() => store.getters['events/getTemplateKey'])

watch(() => templateKey.value, (value) => {
  let templateKeyConfig = templateKey.value;
  formData.value = {
    id: templateKeyConfig?.id || null,
    key: templateKeyConfig?.key || '',
  };

});

function loadTemplateKey(){
  loading.value = true
  store.dispatch('events/loadTemplateKey')
      .catch(() => {})
      .finally(() => loading.value = false)
}

function createTemplateKey() {
  processing.value = true

  store.dispatch('events/saveTemplateKey', formData.value)
      .then(res => {
        window.toastr['success'](i18n.global.t("notification.config_success"))
      })
      .catch(() => {})
      .finally(() => processing.value = false)
}


onMounted(() => {
  loadTemplateKey()
})
</script>


